var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 19.2H1.6V28.8C1.6 29.6487 1.93714 30.4626 2.53726 31.0627C3.13737 31.6629 3.95131 32 4.8 32H27.2C28.0487 32 28.8626 31.6629 29.4627 31.0627C30.0629 30.4626 30.4 29.6487 30.4 28.8V19.2H17.6V22.4H14.4V19.2ZM14.4 17.6H0V8C0 6.24 1.44 4.8 3.2 4.8H9.6V3.2C9.6 2.35131 9.93714 1.53737 10.5373 0.937258C11.1374 0.337142 11.9513 0 12.8 0L19.2 0C20.0487 0 20.8626 0.337142 21.4627 0.937258C22.0629 1.53737 22.4 2.35131 22.4 3.2V4.8H28.8C29.6487 4.8 30.4626 5.13714 31.0627 5.73726C31.6629 6.33737 32 7.15131 32 8V17.6H17.6V14.4H14.4V17.6ZM19.2 4.8V3.2H12.8V4.8H19.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.9f468f7fcd88812ba5c07a172a2810aa.svg";
export { ForwardRef as ReactComponent };